module.exports = __webpack_public_path__ + "img/65.status_head_paper.d3af36ad.svg";